import React, { useState } from "react";
import DMCalendar from "./DMCalendar";
import PostingCalendar from "./work/PostingCalendar";
import { portalWorkApi, staffWorkApi } from "./work/workApi";
import "../assets/css/DigixLeads.css";
import "../assets/css/Projects.css";
import "../assets/css/MyDay.css";
import "./dm/dm.css";
import "../assets/css/PageHeading.css";

/**
 * Standalone CRM page: Digital Marketing only (DM calendar + tenant filter).
 * Same calendar component is embedded on the Dashboard "DM Calendar" tab.
 * With portal=true it is the tenant portal's calendar for the signed-in company.
 * "Calendar map" switches to the month / week / agenda posting calendar across all work.
 */
function DigitalMarketingPage({ portal = false }) {
  const [mode, setMode] = useState("map");
  const toggle = (
    <div className="wk wk-seg" role="group" aria-label="Calendar type" style={{ marginBottom: 12 }}>
      <button type="button" aria-pressed={mode === "map"} onClick={() => setMode("map")}>
        Calendar map
      </button>
      <button type="button" aria-pressed={mode === "week"} onClick={() => setMode("week")}>
        Week planner
      </button>
    </div>
  );
  const calendar =
    mode === "map" ? (
      <div className="dmp-card">
        <PostingCalendar api={portal ? portalWorkApi : staffWorkApi} />
      </div>
    ) : (
      <div className="dmp-card dmp-card--calendar">
        <DMCalendar title={null} portal={portal} />
      </div>
    );

  if (portal) {
    return (
      <div className="cportal-page">
        <div className="cportal-page-head">
          <h1>Calendar</h1>
        </div>
        <div className="dmp">
          {toggle}
          {calendar}
        </div>
      </div>
    );
  }

  return (
    <div className="dmp">
      <div className="co-page-head">
        <h2 className="co-page-head__title">DM Calendar</h2>
      </div>
      {toggle}
      {calendar}
    </div>
  );
}

export default DigitalMarketingPage;
